import {
  EmploymentSalaryRow,
  SalaryTableRow,
  ShiftSalaryRow,
  KtaRow,
  GroupedEmploymentSalaryRow,
} from "../../types/common";
import BulkSalaryIncreaseShiftSalaryRow from "./BulkSalaryIncreaseShiftSalaryRow";
import BulkSalaryIncreaseEmploymentRow from "./BulkSalaryIncreaseEmploymentRow";
import BulkSalaryIncreaseKtaRow from "./BulkSalaryIncreaseKtaRow";
import { ActionMenuState } from "../../../../common/types/commonTypes";
import { MassUpdateStatusRowId } from "../../types/queries";

type Props = {
  id: string;
    rowType: "shift_salaries" | "employment" | "kta" | "tes_tables";
  row: SalaryTableRow;
  index: number;
  setMenu: (menu: ActionMenuState) => void;
  isSelected?: boolean; // injected by parent component
  onSelect?: () => void; // injected by parent component
  raiseDateSalaryKeys: string[];
  afterRaiseDateSalaryPerDateKeys: string[];
  uniqueKtaDates: string[];
  toggleUnclear: (row: MassUpdateStatusRowId) => void;
  toggleExpandedRow: (row: MassUpdateStatusRowId) => void;
};

const BulkSalaryIncreaseRowComponents = ({
  row,
  index,
  setMenu,
  rowType,
  isSelected,
  onSelect,
  raiseDateSalaryKeys,
  afterRaiseDateSalaryPerDateKeys,
  uniqueKtaDates,
  toggleUnclear,
  toggleExpandedRow,
}: Props) => {
  const components = {
    shift_salaries: (
      <BulkSalaryIncreaseShiftSalaryRow
        row={row as ShiftSalaryRow}
        index={index}
        raiseDateSalaryKeys={raiseDateSalaryKeys}
        afterRaiseDateSalaryPerDateKeys={afterRaiseDateSalaryPerDateKeys}
        isSelected={isSelected}
        onSelect={onSelect}
        toggleUnclear={toggleUnclear}
      />
    ),
    employment: (
      <BulkSalaryIncreaseEmploymentRow
        row={row as GroupedEmploymentSalaryRow|EmploymentSalaryRow}
        index={index}
        raiseDateSalaryKeys={raiseDateSalaryKeys}
        afterRaiseDateSalaryPerDateKeys={afterRaiseDateSalaryPerDateKeys}
        isSelected={isSelected}
        onSelect={onSelect}
        toggleUnclear={toggleUnclear}
        toggleExpandedRow={toggleExpandedRow}
      />
    ),
      kta: (
              <BulkSalaryIncreaseKtaRow
              row={row as KtaRow}
              index={index}
              uniqueKtaDates={uniqueKtaDates}
              isSelected={isSelected}
              onSelect={onSelect}
              toggleUnclear={toggleUnclear}
          />
      ),
      tes_tables: (
        <BulkSalaryIncreaseShiftSalaryRow
          row={row as ShiftSalaryRow}
          index={index}
          raiseDateSalaryKeys={raiseDateSalaryKeys}
          afterRaiseDateSalaryPerDateKeys={afterRaiseDateSalaryPerDateKeys}
          isSelected={isSelected}
          onSelect={onSelect}
          toggleUnclear={toggleUnclear}
        />
      ),
  };

  const RowComponent = components[rowType];

  return RowComponent;
};

export default BulkSalaryIncreaseRowComponents;
